import { asMultiStyleConfig } from '../../utils/theme';
export default asMultiStyleConfig({
  parts: ['step', 'icon', 'count', 'noCircle'],
  baseStyle: {
    step: {
      py: 2,
      px: 4,
      fontWeight: 'bold',
      borderBottom: '3px solid',
      color: 'grey.980',
      borderBottomColor: 'grey.300',
      display: 'inline-flex',
      alignItems: 'center',
      flexGrow: ['1', 'unset'],
      bg: 'grey.100',
      _first: {
        borderTopLeftRadius: 'lg'
      },
      _last: {
        borderTopRightRadius: 'lg'
      },
      _hover: {
        color: 'blue.600',
        bg: 'blue.1140'
      },
      _active: {
        color: 'blue.600',
        bg: 'blue.1140'
      },
      _focus: {
        outline: 'none'
      },
      _focusVisible: {
        color: 'blue.600',
        outline: 'none',
        zIndex: '1',
        boxShadow: "0px 0px 3px 2px #4CAAF0"
      },
      _disabled: {
        _hover: {
          cursor: 'default',
          bg: 'grey.100',
          color: 'grey.980'
        }
      }
    },
    icon: {
      position: 'relative',
      right: '0.25rem'
    },
    count: {
      backgroundColor: 'blue.900',
      color: 'white',
      width: '1rem',
      height: '1rem',
      mr: '3px',
      borderRadius: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '0.75rem'
    },
    noCircle: {
      pr: '3px'
    }
  },
  sizes: {
    md: {
      step: {
        h: 14
      }
    },
    lg: {
      step: {
        h: 18,
        p: 6
      }
    }
  },
  variants: {
    active: {
      step: {
        borderBottomColor: 'blue.300',
        _hover: {
          cursor: 'default',
          color: 'grey.980',
          bg: 'grey.100'
        },
        _active: {
          color: 'grey.980',
          bg: 'grey.100'
        }
      }
    },
    completed: {
      step: {
        borderBottomColor: 'blue.600',
        color: 'blue.600'
      }
    }
  },
  defaultProps: {
    size: 'md',
    variant: 'default'
  }
});